import script from "./VitaDrop.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaDrop.vue?vue&type=script&setup=true&lang=ts"

import "./VitaDrop.vue?vue&type=style&index=0&id=6762fcd5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6762fcd5"]])

export default __exports__